import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./auth";
import { ToastProvider } from "./components";
import "./styles.css";
import "./workspace.css";
import "./essential-mode.css";
import "./notifications.css";
import "./foundation.css";
import "./redesign.css";
import "./public-foundation.css";
// La web pública y las pantallas de acceso todavía comparten la composición
// y los tokens de Cochegest Next. Product Craft se carga después y solo
// remata el producto autenticado sin retirar esta base pública.
import "./next.css";
import "./next-dark.css";
// La piel común de la app permanece global. Las capas de marketing,
// escaparate, ventas, taller, ficha y vídeo se cargan con su ruta lazy para
// no obligar a cada usuario a descargar CSS de pantallas que no visita.
import "./next-app.css";
// Fuente visual única para el producto autenticado. Se carga al final para
// evitar que las capas funcionales de cada módulo vuelvan a fragmentar la UI.
import "./product-craft.css";
import "./product-labels.css";
import { reportClientError } from "./api";
import { UiPreferencesProvider } from "./ui-preferences";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <UiPreferencesProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </UiPreferencesProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js");
  });
}

window.addEventListener("error", (event) => {
  void reportClientError("error", event.message || "Error no identificado en el navegador");
});

window.addEventListener("unhandledrejection", (event) => {
  const message = event.reason instanceof Error ? event.reason.message : String(event.reason ?? "Promesa rechazada");
  void reportClientError("unhandled_rejection", message);
});

navigator.serviceWorker?.addEventListener("message", (event) => {
  if (event.data?.type === "navigate" && typeof event.data.url === "string" && event.data.url.startsWith("/")) {
    window.location.assign(event.data.url);
  }
});
